import styled from "styled-components";
import { generic as sg } from "../../_themes/constants";
import { Icon } from "../../IconSVG";

export const SpinIcon = styled(Icon)`
  position: relative;
  z-index: ${sg.layers.game + 1};
  vertical-align: top;
`;

export const StopIcon = styled(SpinIcon)`
  top: -100%;
  z-index: ${sg.layers.game};
  opacity: 0;
`;
